module.exports = __webpack_public_path__ + "static/media/minimal.4fac923a.jpg";